export enum ServiceType {
  Service = 1,
  GymMembership = 2,
  GymGroup = 3
}
